import { createI18n, LocaleMessageValue, Path, VueMessageType } from "vue-i18n";
import { App, nextTick } from "vue";
import { LanguageInfo,  LocalizationInfo } from "./types";
import en from '../language/en.json';
   
type MessageSchema = typeof en;
type SupportLocale = 'en';


class Localization {
  private i18n: any; 

  private defaultLanguage : LanguageInfo ; 
  private supportedLanguages: Array<LanguageInfo> = []; 
  private localMessagePath : string = ""

  constructor() 
  {
    this.defaultLanguage = new LanguageInfo("en","English", 'en.json', true);

    this.i18n = createI18n<[MessageSchema], SupportLocale>({
                    legacy: false, // Must be false to use the Composition API
                    locale: this.defaultLanguage.code, // Set the initial locale
                    fallbackLocale: this.defaultLanguage.code,
                    messages: { 
                        en : en
                      },
                  });
                 
  }

  public use(app:App, localizationInfo: LocalizationInfo)  
  {
    this.localMessagePath = localizationInfo.localMessageResourcePath;
    this.supportedLanguages = localizationInfo.languages;

    var englishLanguage = new LanguageInfo("en","English", 'en.json', true);
    const defaultlanguages = this.supportedLanguages.filter( x => x.isDefault);
    if(defaultlanguages.length == 0)
    {
      this.defaultLanguage = this.supportedLanguages[0] ?? englishLanguage;
    }
    else
    {
      this.defaultLanguage = defaultlanguages[0] ?? englishLanguage;
    }

    //console.log("using localization plugin module, set "+ this.defaultLanguage.code + "  [" + this.defaultLanguage.displayName +"] as the default language");
    //console.log("this application support the following languages: ")
    //this.supportedLanguages.forEach( x => console.log(x.code + "  [" + x.displayName + "]") )
    app.use(this.i18n);
  }
   
  public localizer(key: Path, namedParameters: Record<string, unknown>|undefined = undefined): string
  {
    if(namedParameters !== undefined)
    {
      return this.i18n.global.t(key, namedParameters);
    }
    else
    {
      return this.i18n.global.t(key);
    }
  }

  get LocalLanguageCode() : string
  {
    const localLanguage = localStorage.getItem("localLanguage");
    if(localLanguage === null)
      return this.defaultLanguage.code;

    return localLanguage;
  }

  public SwitchLanguage(specifyLanguageCode: string | undefined)
  {
    var localLanguageCode : string = this.defaultLanguage.code;
    if(specifyLanguageCode === undefined || specifyLanguageCode === null || specifyLanguageCode.trim() === "")
    {
        //the default language
        localLanguageCode = this.defaultLanguage.code;
        //console.log(`No language specified. Switch to the default language[code = ${localLanguageCode}]`)
    }
    else
    {
      specifyLanguageCode = specifyLanguageCode.toLowerCase();
       //use the default language if application does not support the specify language
      if (!this.supportedLanguages.some(x => x.code == specifyLanguageCode)) {
        localLanguageCode = this.defaultLanguage.code;
        //console.log(`Unable to switch the application to an unsupported language[Code = ${specifyLanguageCode}]. Use the default language[code = ${localLanguageCode}] instead`)
      }
      else
      {
        localLanguageCode = specifyLanguageCode;
        //console.log(`Try switching the application to the specified language[Code = ${specifyLanguageCode}].`)
      }
    }

    //store the current language in local storage. 
    localStorage.setItem("localLanguage", localLanguageCode);
  }
 
  public async loadLocaleMessages(): Promise<void> 
  {
    const localLanguageCode = this.LocalLanguageCode;
    
    try {

      //if the message already loaded, no need to load message again, just set the local message
      if (this.i18n.global.availableLocales.includes(localLanguageCode)) {
        if(this.getI18nLocalLanguage() === localLanguageCode)
        {
          //console.log(`the language[code = ${localLanguageCode}] has beed applied for the application. Just keep the current language setting`)
        }
        else
        {
          //console.log(`the messages of the language[code = ${localLanguageCode}] has beed loaded, just set it as the current lanugage again.`)
          var message = this.i18n.global.getLocaleMessage(localLanguageCode);
          this.ApplyLocalLanguage(localLanguageCode, message);
        }
        
        return nextTick();
      }

      //load local message resource
      const languageInfo = this.supportedLanguages.find( x => x.code === localLanguageCode) || this.defaultLanguage;
      const messageFileName = languageInfo.localMessageFileName;
      const messages = await import(/* webpackChunkName: "locale-[request]" */ `../language/${messageFileName}`);
      //console.log(`loading the messages of the language[code = ${localLanguageCode}] from ../${this.localMessagePath}/${messageFileName} file`)

      //set i18n local language and local language message 
      this.ApplyLocalLanguage(localLanguageCode, messages.default);
      return nextTick();
    } catch (error) {
      //console.error(`Failed to load the language[code = ${localLanguageCode}] message`, error);

      return nextTick();
    }
  }

  private ApplyLocalLanguage(localeLanguageCode: string,message: LocaleMessageValue<VueMessageType>) 
  {
    //set language in i18n
    this.SetI18nLocalLanguage(localeLanguageCode);

    //set language message in i18n
    this.i18n.global.setLocaleMessage(localeLanguageCode, message);

    //show the current application's language resource
    document.querySelector("html")?.setAttribute("language", localeLanguageCode);
  }
   
  public getI18nLocalLanguage() : string
  {
    // if (this.i18n.mode === "legacy") {
    //    return this.i18n.global.locale;
    //  } else {
      return this.i18n.global.locale.value;
    //}
  }

  public getI18nLocal() : any
  {
      return this.i18n.global.locale;
  }

  private SetI18nLocalLanguage(localeLanguageCode: string) {
    //  if (this.i18n.mode === "legacy") {
    //    this.i18n.global.locale = localeLanguageCode;
    //  } else {
      this.i18n.global.locale.value = localeLanguageCode;
    //}
  }
}

export default Localization;